import { render, staticRenderFns } from "./BRRD.vue?vue&type=template&id=152d706b&"
import script from "./BRRD.vue?vue&type=script&lang=js&"
export * from "./BRRD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports